import React from 'react';
import { useTranslation } from 'react-i18next';
import { SegmentedControl } from './SegmentedControl';

/** EN / ID toggle. */
export const LanguageSwitcher: React.FC = () => {
    const { i18n, t } = useTranslation();
    const value = i18n.language?.startsWith('id') ? 'id' : 'en';
    return (
        <SegmentedControl
            aria-label={t('common.switchLanguage')}
            value={value}
            onChange={(v) => i18n.changeLanguage(v)}
            options={[{ value: 'en', label: 'EN' }, { value: 'id', label: 'ID' }]}
        />
    );
};

export default LanguageSwitcher;
